import "core-js/modules/es.array.concat.js";
import i18n from 'i18n';
import formatHelixScore from './formatHelixScore';
export default function getHelixGraphTooltip() {
  var outOf = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 100;
  var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  return function tooltipReadout(value, label) {
    return value !== null ? "".concat(label, ": ").concat(formatHelixScore(value, {
      outOf: outOf,
      decimalPlaces: decimalPlaces
    })) : "".concat(label, ": ").concat(i18n.t('skills_no_score'));
  };
}